<template>
  <div>
    <label
      :for="`${field.name}`"
      class="block text-sm font-medium text-gray-700"
    >
      {{ field.label }}<span v-if="field.required">*</span>
    </label>
    <input
      type="text"
      :id="field.name"
      :name="field.name"
      class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
      :required="field.required"
      :value="value"
      @input="$emit('input', $event)"
    />
    <p v-if="field.explainer" class="text-sm text-gray-500">
      {{ field.explainer }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'TextField',
  props: {
    field: Object,
    value: String,
  },
};
</script>
